import api from '../api'

import { MetaTagEndpoints, MetaTags } from './'
import type { MetaTagInfo } from './'

class MetaTagService {
  static async getLinkPreviewMetatag(url: string, metaTags: MetaTags[]) {
    const metaTagKey = 'metaTags'
    const params = new URLSearchParams({
      url
    })

    metaTags.forEach((metaTag: MetaTags) => params.append(metaTagKey, metaTag))

    const { data } = await api.get<MetaTagInfo>(MetaTagEndpoints.linkPreview(), {
      params
    })

    return data
  }
}

export default MetaTagService
